/* ---------- Color variant selector ---------- */
const bike = document.getElementById('bikeSvg');
const colorName = document.getElementById('colorName');
document.querySelectorAll('.swatch').forEach(btn=>{
  btn.addEventListener('click', ()=>{
    document.querySelectorAll('.swatch').forEach(s=>s.setAttribute('aria-pressed','false'));
    btn.setAttribute('aria-pressed','true');
    bike.style.color = btn.dataset.color;
    colorName.textContent = btn.dataset.name;
    var bc = document.getElementById('buyColor'); if(bc) bc.textContent = btn.dataset.name;
  });
});

/* ---------- FAQ accordion ---------- */
document.querySelectorAll('.faq-q').forEach(q=>{
  q.addEventListener('click', ()=>{
    const item = q.closest('.faq-item');
    const ans = q.nextElementSibling;
    const open = item.classList.toggle('open');
    q.setAttribute('aria-expanded', open);
    ans.style.maxHeight = open ? ans.scrollHeight + 'px' : 0;
  });
});

/* ---------- Mobile nav ---------- */
const mNav = document.getElementById('mobileNav');
const overlay = document.getElementById('overlay');
const openBtn = document.getElementById('menuToggle');
function setMenu(open){
  mNav.classList.toggle('open', open);
  overlay.classList.toggle('show', open);
  openBtn.setAttribute('aria-expanded', open);
  document.body.style.overflow = open ? 'hidden' : '';
}
openBtn.addEventListener('click', ()=>setMenu(true));
document.getElementById('menuClose').addEventListener('click', ()=>setMenu(false));
overlay.addEventListener('click', ()=>setMenu(false));
mNav.querySelectorAll('a').forEach(a=>a.addEventListener('click', ()=>setMenu(false)));

/* ---------- Scroll reveal ---------- */
const io = new IntersectionObserver((entries)=>{
  entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
},{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

/* ---------- Hero carousel ---------- */
(function(){
  var slides = Array.prototype.slice.call(document.querySelectorAll('.hslide'));
  var dots   = Array.prototype.slice.call(document.querySelectorAll('.hdot'));
  if(!slides.length) return;
  var i = 0, timer;
  function show(n){
    i = (n + slides.length) % slides.length;
    slides.forEach(function(s,k){ s.classList.toggle('is-active', k===i); });
    dots.forEach(function(d,k){ d.classList.toggle('is-active', k===i); });
  }
  function start(){ timer = setInterval(function(){ show(i+1); }, 8000); }
  function stop(){ clearInterval(timer); }
  var pr = document.getElementById('heroPrev'), nx = document.getElementById('heroNext');
  if(pr) pr.addEventListener('click', function(){ show(i-1); stop(); start(); });
  if(nx) nx.addEventListener('click', function(){ show(i+1); stop(); start(); });
  dots.forEach(function(d){ d.addEventListener('click', function(){ show(parseInt(d.dataset.i,10)); stop(); start(); }); });
  var hero = document.getElementById('hero');
  if(hero){ hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', start); }
  start();
})();

/* ---------- Quantity stepper ---------- */
(function(){
  var v = document.getElementById('qtyVal'),
      m = document.getElementById('qtyMinus'),
      p = document.getElementById('qtyPlus');
  if(!v) return;
  var q = 1;
  if(m) m.addEventListener('click', function(){ q = Math.max(1, q-1); v.textContent = q; });
  if(p) p.addEventListener('click', function(){ q = Math.min(9, q+1); v.textContent = q; });
})();

/* ---------- Testimonial slider (mirrors hero carousel) ---------- */
(function(){
  var slides = Array.prototype.slice.call(document.querySelectorAll('.t-slide'));
  var dots   = Array.prototype.slice.call(document.querySelectorAll('.t-dot'));
  if(!slides.length) return;
  var i = 0, timer;
  function show(n){
    i = (n + slides.length) % slides.length;
    slides.forEach(function(s,k){ s.classList.toggle('is-active', k===i); });
    dots.forEach(function(d,k){ d.classList.toggle('is-active', k===i); });
  }
  function start(){ timer = setInterval(function(){ show(i+1); }, 6000); }
  function stop(){ clearInterval(timer); }
  var pr = document.getElementById('tPrev'), nx = document.getElementById('tNext');
  if(pr) pr.addEventListener('click', function(){ show(i-1); stop(); start(); });
  if(nx) nx.addEventListener('click', function(){ show(i+1); stop(); start(); });
  dots.forEach(function(d){ d.addEventListener('click', function(){ show(parseInt(d.dataset.i,10)); stop(); start(); }); });
  var box = document.getElementById('tSlider');
  if(box){ box.addEventListener('mouseenter', stop); box.addEventListener('mouseleave', start); }
  start();
})();
